module.exports = __webpack_public_path__ + "static/media/v.4b1cff09.png";